// extracted by mini-css-extract-plugin
export var closeButton = "_hr-1";
export var closeX = "_hr-3";
export var container = "_hr-0";
export var image = "_hr-2";